import React from 'react';
import { connect } from 'react-redux';
import Modal from '../../../shared/modal/content';
import PopupHeader from '../../popupHeader';
import CenterPanelUpdate from './centerPanelUpdate';
import CenterPanelView from './centerPanelView';
import RightPanel from './rightPanel';

export default function SupportContactModalContent(props) {
  const isEmpty = (value) => {
    if (value) {
      return false;
    }
    return true;
  };

  let defaultValueIsPicked =
    isEmpty(props.supportContactForm.supportName) &&
    isEmpty(props.supportContactForm.supportEmail) &&
    isEmpty(props.supportContactForm.supportPhone) &&
    isEmpty(props.supportContactForm.supportWebsite);

  let centerPanel = '';
  if (props.updateOrView == 'update') {
    centerPanel = (
      <CenterPanelUpdate
        supportContactForm={props.supportContactForm}
        defaultValueIsPicked={defaultValueIsPicked}
        waitingArea={props.waitingArea}
      />
    );
  } else {
    centerPanel = (
      <CenterPanelView
        supportContactForm={props.supportContactForm}
        defaultValueIsPicked={defaultValueIsPicked}
        waitingArea={props.waitingArea}
      />
    );
  }

  return (
    <Modal show={props.showSupportContactModal} hideWhenClickAway={false}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpSupportContact}
        title={APP.LANGUAGE.SupportContactModal.Title}
        subtitle={(props.waitingArea ? props.waitingArea.name : '') + ' (' + props.waitingArea.organisationName + ')'}
      />
      <div className="content">
        <div className="main-ui-container waiting-area-during-calls">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <RightPanel
                updateOrView={props.updateOrView}
                defaultValueIsPicked={defaultValueIsPicked}
                waitingAreaId={props.waitingArea.id}
                supportContactForm={props.supportContactForm}
              />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <RightPanel
                updateOrView={props.updateOrView}
                defaultValueIsPicked={defaultValueIsPicked}
                waitingAreaId={props.waitingArea.id}
                supportContactForm={props.supportContactForm}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
